import React from 'react';

import EmployeeCategory from './EmployeeCategory';
import TodoList from './TodoList';
import SystemAnnounces from './SystemAnnounces';
import Setup from './Setup';
import styles from './AdminDashboard.scss';
import EmployeeMemo from './EmployeeMemo';
import ExpensesMonthly from './ExpensesMonthly';

import TotalEmployee from './TotalEmployee';
import ExpenseSummaryChart from './ExpenseSummary';
import StartTutorial from './StartTutorial';
import CheckWaitingTutorial from '../../GuideTour/ContinueWorkingTutorial/CheckWaitingTutorial';
import TutorialProvider from '../../GuideTour/TutorialProvider';

const AdminDashboard = props => {
  const {
    systemAnnounces,
    mostRecentNotConfirmedSalary,
    notCompletedSetting,
    numberEmployees,
    expensesSummary,
    employeeCategories,
    monthlyExpenseSummary,
    expensesSummaryYearList,
    memos,
    currentUser
  } = props;

  return (
    <React.Fragment>
      <SystemAnnounces systemAnnounces={systemAnnounces} />
      <TutorialProvider>
        <CheckWaitingTutorial notCompletedSetting={notCompletedSetting} currentUser={currentUser} />

        {notCompletedSetting.length > 0 ? (
          <React.Fragment>
            <div className="l-flex">
              <Setup notCompletedSetting={notCompletedSetting} />
            </div>
            <StartTutorial notCompletedSetting={notCompletedSetting} currentUser={currentUser} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="l-flex">
              <div className="l-flex1-main">
                <TodoList {...{ mostRecentNotConfirmedSalary }} />
              </div>

              <div className="l-flex1-sub">
                <TotalEmployee numberEmployees={numberEmployees} />
              </div>
            </div>

            <div className={`l-flex ${styles.reverse}`}>
              <div className="l-flex1-main">
                <ExpensesMonthly monthlyExpenseSummary={monthlyExpenseSummary} />
              </div>

              <div className="l-flex1-sub">
                <EmployeeCategory employeeCategories={employeeCategories} />
              </div>
            </div>

            <div className="l-flex">
              <div className="l-flex1-main">
                <ExpenseSummaryChart expensesSummary={expensesSummary} yearLists={expensesSummaryYearList} />
              </div>

              <div className="l-flex1-sub">
                <EmployeeMemo monthMemos={memos} />
              </div>
            </div>
          </React.Fragment>
        )}
      </TutorialProvider>
    </React.Fragment>
  );
};

export default AdminDashboard;
